/**
 * EL PANEL AVISA CUANDO HAY VERSION NUEVA (PANEL-VERSION-NUEVA-T1, ASSIGN #17224).
 *
 * QUE PASO. 21-sep: nueve deploys del panel en el dia, y Josse probo dos veces (15:27 y 15:38)
 * sobre el codigo de antes de las 15:00 sin saberlo: la pestana seguia abierta y un SPA no baja el
 * bundle nuevo al navegar. Se ve en api_peticiones: la firma de los tres recorridos viejos. Le pasa
 * igual a cualquier dueno que deja el panel abierto todo el dia.
 *
 * YA HABIA UN AVISO y nunca salto: el de index.html depende de que cambie sw.js, y sw.js tiene su
 * CACHE_VERSION clavado en v2.2.33. Lo que si cambia en cada deploy es /version.json (PANEL-VERSION-T1).
 *
 * LA REGLA: el build graba su commit (__APP_COMMIT__); se compara con el de /version.json. Si el
 * servido es otro, hay version nueva. Nunca se recarga solo: se ofrece.
 *
 * LIMITE DE ARES: como mucho una consulta cada 5 minutos, tambien al volver a la pestana. No se
 * suman peticiones al problema de hoy.
 *
 * Sin DOM: lo prueba scripts/check-version-nueva.mjs.
 */

export const CADA_MS = 5 * 60 * 1000;

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** true si /version.json dice que se sirve otro commit que el que esta corriendo. */
export function hayVersionNueva(corriendo, servida) {
  const mio = texto(corriendo?.commit);
  const alla = texto(servida?.commit);
  // En desarrollo el commit es 'local' o no hay version.json: nunca se avisa.
  if (!mio || !alla || mio === 'local' || alla === 'local') return false;
  return mio !== alla;
}

/**
 * El vigia: revisar(motivo) consulta como mucho una vez cada CADA_MS, pase lo que pase. Cuando
 * encuentra version nueva llama alAviso una sola vez y deja de consultar.
 * @param {{corriendo:{commit:string,version?:string}, leer:()=>Promise<object|null>, alAviso:(servida:object)=>void, ahora?:()=>number}} o
 */
export function crearVigia({ corriendo, leer, alAviso, ahora = () => Date.now() }) {
  let ultima = -Infinity;
  let avisado = false;
  let enCurso = false;
  let consultas = 0;
  return {
    get consultas() { return consultas; },
    async revisar() {
      if (avisado || enCurso) return false;
      const t = ahora();
      if (t - ultima < CADA_MS) return false;
      ultima = t;
      enCurso = true;
      consultas++;
      try {
        const servida = await leer();
        if (hayVersionNueva(corriendo, servida)) {
          avisado = true;
          alAviso(servida);
          return true;
        }
      } catch { /* sin red o sin version.json: se prueba en la proxima ventana */ }
      finally { enCurso = false; }
      return false;
    }
  };
}
